export const GET_DELIVERY_AREAS_REQUEST = 'GET_DELIVERY_AREAS_REQUEST'
export const GET_DELIVERY_AREAS = 'GET_DELIVERY_AREAS'
export const GET_DELIVERY_AREAS_REQUEST_PENDING = 'GET_DELIVERY_AREAS_REQUEST_PENDING'
export const GET_DELIVERY_AREAS_REQUEST_SUCCESS = 'GET_DELIVERY_AREAS_REQUEST_SUCCESS'
export const GET_DELIVERY_AREAS_REQUEST_ERROR = 'GET_DELIVERY_AREAS_REQUEST_ERROR'
export const PULL_DELIVERY_AREAS_REQUEST = 'PULL_DELIVERY_AREAS_REQUEST'

export const UPDATE_DELIVERY_AREA_GOVERNORATE_REQUEST = 'UPDATE_DELIVERY_AREA_GOVERNORATE_REQUEST'

